import React, { InputHTMLAttributes } from 'react';
import './Input.css';
import Stack from '../Stack/Stack';
import { Link } from '@/types/core/Link';
import Button from '../Button/Button';
type BaseInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'type' | 'value' | 'checked'>;

interface InputProps extends BaseInputProps {
  type?: 'text' | 'number' | 'checkbox' | 'color';
  value?: string | number | boolean;
  onChange?: (value: string | number | boolean) => void;
  className?: string;
  prefix?: string;
  suffix?: string;
  linkable?: boolean;
  link?: Link;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  value,
  onChange,
  className = '',
  prefix,
  suffix,
  linkable = false,
  link,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;

    if (type === 'number') {
      onChange(parseFloat(e.target.value) || 0);
    } else if (type === 'checkbox') {
      onChange(e.target.checked);
    } else {
      onChange(e.target.value);
    }
  };

  // Ensure value is properly formatted for the input
  const inputValue = type === 'number' 
    ? value || 0
    : type === 'checkbox'
    ? undefined
    : value || '';

  return (
    <Stack direction="horizontal" gap="no" align="center" className={`input ${className}`}>
      {prefix && <span className="input__prefix">{prefix}</span>}
      <input
        {...props}
        type={type}
        value={type !== 'checkbox' ? inputValue as string | number : undefined}
        checked={type === 'checkbox' ? Boolean(value) : undefined}
        onChange={handleChange}
        className={`input ${className}`}
      />
      {suffix && <span className="input__suffix">{suffix}</span>}
      {linkable && (
        <Button
          icon={link ? "LinkConnected" : "Link"}
          onClick={() => {
            // TODO: Implement link handling
          }}
          className="input__link-button"
        />
      )}
    </Stack>
  );
};

export default Input; 
